import { useEffect, useState } from 'react'

import useWebsocket from '../useWebsocket/useWebsocket'

const useWebsocketAction = ({ websocketUrl, onComplete, onError, onClose }) => {
  const [isInProgress, setIsInProgress] = useState(Boolean(websocketUrl))

  const handleMessage = message => {
    if (message?.status === 'completed') {
      setIsInProgress(false)
      close()
      onComplete?.(message)
    }

    if (message?.status === 'failed') {
      setIsInProgress(false)
      close()
      onError?.(message)
    }
  }

  const handleError = () => {
    setIsInProgress(false)
    onError?.()
  }

  const { close } = useWebsocket({
    url: websocketUrl,
    onMessage: handleMessage,
    onError: handleError,
    onClose,
  })

  useEffect(() => {
    setIsInProgress(Boolean(websocketUrl))
  }, [websocketUrl])

  return { isInProgress }
}

export default useWebsocketAction
